/**
 * Design System Défi Gourmand — maquette "design system"
 * v1.2.0 - Palette, surfaces, bordures, statuts
 */

export const designSystem = {
  primary: "#1c2118", // Primary Green — Marque & Navigation
  secondary: "#E67E22", // Warm Orange — Accents & CTA
  backgroundLight: "#f7f8f6",
  backgroundDark: "#181f13",
  success: "#2E7D32",
  warning: "#ED6C02",
  error: "#D32F2F",
  ivory: "#FEFEFE",
  borderLight: "#ecf1e9",
  borderDark: "#2d3a24",
  surfaceDark: "#202919",
  surfaceDarkAlt: "#131910",
  textLight: "#131910",
  textDark: "#fafbf9",
  muted: "#6d8d58",
} as const;

export const colors = {
  primary: {
    main: designSystem.primary,
    light: "#4A7C2A",
    dark: "#1A3009",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: designSystem.secondary,
    light: "#f0a050",
    dark: "#c96a1a",
    contrastText: "#FFFFFF",
  },
  background: {
    default: designSystem.backgroundLight,
    paper: designSystem.ivory,
  },
  text: {
    primary: designSystem.textLight,
    secondary: designSystem.muted,
  },
  error: {
    main: designSystem.error,
    light: "#ef5350",
    dark: "#b71c1c",
  },
  warning: {
    main: designSystem.warning,
    light: "#ff9800",
    dark: "#e65100",
  },
  success: {
    main: designSystem.success,
    light: "#4caf50",
    dark: "#1b5e20",
  },
  info: {
    main: "#1976d2",
    light: "#42a5f5",
    dark: "#1565c0",
  },
  grey: {
    50: "#f9fafb",
    100: "#f3f4f6",
    200: "#e5e7eb",
    300: "#d1d5db",
    400: "#9ca3af",
    500: "#6b7280",
    600: "#4b5563",
    700: "#374151",
    800: "#1f2937",
    900: "#111827",
  },
  status: {
    pending: {
      bg: "#e5e7eb",
      text: "#374151",
      border: "#d1d5db",
      dot: "#6b7280",
    },
    inProgress: {
      bg: "#fef3c7",
      text: "#92400e",
      border: "#fde68a",
      dot: "#f59e0b",
    },
    delivered: {
      bg: "rgba(46, 125, 50, 0.2)",
      text: designSystem.success,
      border: "rgba(46, 125, 50, 0.4)",
      dot: designSystem.success,
    },
    inDelivery: {
      bg: "rgba(230, 126, 34, 0.2)",
      text: designSystem.secondary,
      border: "rgba(230, 126, 34, 0.4)",
      dot: designSystem.secondary,
    },
    cancelled: {
      bg: "rgba(211, 47, 47, 0.2)",
      text: designSystem.error,
      border: "rgba(211, 47, 47, 0.4)",
      dot: designSystem.error,
    },
    confirmed: {
      bg: "#dbeafe",
      text: "#1e40af",
      border: "#93c5fd",
      dot: "#3b82f6",
    },
    ready: {
      bg: "#e9d5ff",
      text: "#6b21a8",
      border: "#c084fc",
      dot: "#9333ea",
    },
  },
  border: {
    light: designSystem.borderLight,
    dark: designSystem.borderDark,
  },
  customerType: {
    institution: {
      bg: "#dbeafe",
      text: "#1e40af",
    },
    company: {
      bg: "#f3e8ff",
      text: "#6b21a8",
    },
    individual: {
      bg: "#f3f4f6",
      text: "#1f2937",
    },
  },
};

export const getColors = (mode: "light" | "dark" = "light") => {
  if (mode === "dark") {
    return {
      background: designSystem.backgroundDark,
      surface: designSystem.surfaceDark,
      text: {
        primary: designSystem.textDark,
        secondary: designSystem.muted,
      },
      border: designSystem.borderDark,
    };
  }
  return {
    background: designSystem.backgroundLight,
    surface: designSystem.ivory,
    text: {
      primary: designSystem.textLight,
      secondary: designSystem.muted,
    },
    border: designSystem.borderLight,
  };
};
